/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import {
    Paper,
    Stack,
    Typography,
    ToggleButtonGroup,
    ToggleButton,
    Slider,
    Button,
    Divider,
} from '@mui/material';
import { LocalHospital, School, CropFree } from '@mui/icons-material';

const themeColor = '#002755';

const LifestyleControlPanel = ({
    activeType,
    onTypeChange,
    radius,
    onRadiusChange,
    onAreaSelect,
    onAreaReset,
}) => (
    <Paper
        elevation={0}
        sx={{
            p: 3,
            borderRadius: 3,
            border: '1px solid #e3e7f0',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
        }}
    >
        <Stack spacing={2}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: themeColor }}>
                생활 정보 범위 설정
            </Typography>
            <Typography variant="body2" color="text.secondary">
                관심 시설 유형과 반경을 선택하고 지도에서 분석을 수행하세요.
            </Typography>
        </Stack>

        <Stack spacing={1}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                시설 유형
            </Typography>
            <ToggleButtonGroup
                exclusive
                value={activeType}
                onChange={(_, value) => value && onTypeChange?.(value)}
                sx={{
                    '& .MuiToggleButton-root': {
                        flex: 1,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                    },
                }}
            >
                <ToggleButton value="hos">
                    <LocalHospital fontSize="small" sx={{ mr: 0.5 }} />
                    의료
                </ToggleButton>
                <ToggleButton value="edu">
                    <School fontSize="small" sx={{ mr: 0.5 }} />
                    교육
                </ToggleButton>
            </ToggleButtonGroup>
        </Stack>

        <Divider />

        <Stack spacing={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    검색 반경 (m)
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {radius}m
                </Typography>
            </Stack>
            <Slider
                value={radius}
                onChange={(_, value) => onRadiusChange?.(value)}
                min={200}
                max={2000}
                step={100}
                valueLabelDisplay="auto"
                sx={{ color: themeColor }}
            />
        </Stack>

        <Stack spacing={1}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                지도 영역 선택
            </Typography>
            <Stack direction="row" spacing={1.5}>
                <Button
                    variant="contained"
                    startIcon={<CropFree />}
                    onClick={onAreaSelect}
                    sx={{ flex: 1, bgcolor: themeColor, '&:hover': { bgcolor: '#001b3d' } }}
                >
                    영역 선택
                </Button>
                <Button variant="outlined" onClick={onAreaReset} sx={{ flex: 1 }}>
                    선택 해제
                </Button>
            </Stack>
        </Stack>
    </Paper>
);

LifestyleControlPanel.propTypes = {
    activeType: PropTypes.string,
    onTypeChange: PropTypes.func,
    radius: PropTypes.number.isRequired,
    onRadiusChange: PropTypes.func.isRequired,
    onAreaSelect: PropTypes.func.isRequired,
    onAreaReset: PropTypes.func.isRequired,
};

export default LifestyleControlPanel;

